import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';
import qs from 'qs';

export const assetFormService = {
  getForm,
  storeOrUpdate,
  destroy,
};

function getForm(params = {}) {
  const queryString = qs.stringify({ ...params}, { addQueryPrefix: true });
  return (
    axios
      .get(
        `${apiEndpoint.assetForm}/get-form${queryString}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if (res && res.status === 200 && res.data.code === '0000') {
          return res.data;
        }
      })
  );
}

function storeOrUpdate(data, id = null){
  return (id ? (
    axios
      .put(
        apiEndpointFunction.assetForm(id),
        data,
        {
          headers: authHeader(),
        }
      )
  ) : (
    axios
      .post(
        apiEndpoint.assetForm,
        data,
        {
          headers: authHeader()
        }
      )
  )).then(res => {
    if(res && res.status === 200){
      return res.data;
    }
    return {};
  });
}

function destroy(id){
  return (
    axios
      .delete(
        apiEndpointFunction.assetForm(id),
        {
          headers: authHeader()
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
      })
  );
}

